import { Controller } from "@hotwired/stimulus";

// Sends the browser somewhere the moment this element appears, so a background job's
// result can become a flash.
export default class extends Controller {
  static values = { url: String };

  connect() {
    if (!this.urlValue) return;
    Turbo.visit(this.urlValue, { action: "replace" });
  }
}
